var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.loaderBg},[_c('span',{class:[_vm.$style.loader, ( _obj = {}, _obj[_vm.$style.loaderDark] = _vm.isDark, _obj[_vm.$style.loaderLight] = !_vm.isDark, _obj )
    ]})])}
var staticRenderFns = []

export { render, staticRenderFns }